import {
  Box,
  CircularProgress,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppHeader from "../../../components/Header";
import { getSettings } from "../../../services/Auth";

function PrivacyPolicy() {
  const [inputVall, setInputVall] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchterms();
  }, []);

  const fetchterms = async () => {
    setIsLoading(true);
    try {
      const response = await getSettings();
      let data = response?.data?.data;
      if (response.status === 200 || response.status === 201) {
        setInputVall(data);
      } else {
        console.error("Failed to fetch data: Invalid status", response.status);
      }
    } catch (error) {
      console.error("Error fetching tips:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AppHeader>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 5 }}>
          <Typography variant="h4" gutterBottom>
            Privacy Policy
          </Typography>

          {isLoading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : (
            <div
              dangerouslySetInnerHTML={{ __html: inputVall?.privacy }}
              style={{ lineHeight: 1.6, fontSize: "16px" }}
            />
          )}
        </Paper>
      </Container>
    </AppHeader>
  );
}

export default PrivacyPolicy;
